module.exports = Promise.all([__parcel__import__("f6akO"), __parcel__import__("2xLVB")]).then(() => parcelRequire('g36Vt'));